








































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IFilter, ISorter } from "@/models/tables";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { DataModules } from "@/store/modules/data";
import { FilterOperators, FilterTypes } from "@/data/table";
import { ImportLogLevels } from "@/data/enums/imports";
import { IImport, IImportLog } from "@/models/imports";

@Component
export default class ImportLogsTable extends Mixins(
  FilteringSortingTableStore
) {
  @Prop({ required: true })
  public importId!: IImport["id"];

  @Prop({ default: "ILT1" })
  public declare id: IImport["id"];

  public defaults = {
    limit: 8
  };

  public filters: IFilter[] = [
    {
      key: "message",
      label: this.$t("_.message"),
      type: FilterTypes.STRING,
      operator: FilterOperators.CONTAINS
    },
    {
      key: "level",
      label: this.$t("_.log_level"),
      type: FilterTypes.SELECT_CHECKBOX,
      options: [
        { value: ImportLogLevels.INFO, label: this.$t("_.info") },
        { value: ImportLogLevels.WARNING, label: this.$t("_.warning") },
        { value: ImportLogLevels.ERROR, label: this.$t("_.error") }
      ],
      operator: FilterOperators.EQUAL
    },
    {
      key: "created_at",
      label: this.$t("_.created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  public sorters: ISorter[] = [
    {
      field: "created_at",
      label: this.$t("_.date_created")
    }
  ];

  public dataModule = DataModules.IMPORTS_LOGS;

  public created() {
    if (!this.$userCan("list_import_logs")) return;
    this.getData();
  }

  // Override mixin method
  public getStoreParams(params: any): any {
    return {
      importId: this.importId,
      payload: params
    };
  }

  public levelIconProps(level: IImportLog["level"]) {
    switch (level) {
      case ImportLogLevels.ERROR:
        return {
          icon: "exclamation-circle",
          type: "is-danger"
        };
      case ImportLogLevels.WARNING:
        return {
          icon: "exclamation-circle",
          type: "is-caution"
        };
      case ImportLogLevels.INFO:
      default:
        return {
          icon: "info-circle",
          type: "is-info"
        };
    }
  }

  public openLogModal(log: IImportLog) {
    this.$store.dispatch("ui/open/slideModal", {
      config: {
        component: () =>
          import("@/components/app/admin/imports/importLogModal.vue"),
        props: {
          log
        }
      }
    });
  }
}
